function normalizeName(value) {
  const raw = String(value || '').trim();
  if (!raw) return 'Unbekannt';

  const cleaned = raw
    .replace(/[^a-zA-Z0-9äöüÄÖÜß\-\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!cleaned) return 'Unbekannt';
  return cleaned.replace(/\s+/g, '_');
}

function normalizeYear(value) {
  const year = Number(value);
  return Number.isInteger(year) && year > 0 ? String(year) : 'Unbekanntes_Jahr';
}

export function buildLogbuchSingleFilename({ fullName, year }) {
  return `Logbuch_${normalizeName(fullName)}_${normalizeYear(year)}.pdf`;
}

export function buildLogbuchCombinedFilename({ year }) {
  return `Logbuch_Sammel_${normalizeYear(year)}.pdf`;
}
